<template>
  <div class="container my-5">
    <Login @loggedIn="loggedIn" v-bind:user-id="userId"/>
    <InstructorTable v-if="show" v-bind:authorizationToken="authorizationToken" v-bind:clientLogin="clientLogin"/>
  </div>
</template>

<script>
import Login from './components/Login.vue'
import InstructorTable from './components/InstructorTable.vue'

export default {
  data() {
    let urlSearchParams = new URLSearchParams(window.location.search);
    let userId = urlSearchParams.has('userId') ? urlSearchParams.get('userId') : '';
    let clientLogin = urlSearchParams.has('clientLogin') ? urlSearchParams.get('clientLogin') : '';

    return {
      show: false,
      authorizationToken: '',
      userId: userId,
      clientLogin: clientLogin
    }
  },
  components: {
    Login, InstructorTable
  },
  methods: {
    loggedIn(authorizationToken) {
      this.show = (authorizationToken !== '');
      this.authorizationToken = authorizationToken;
    }
  }
}
</script>